import styles from './TicketsDetails.module.css';
import { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { useTranslation } from 'react-i18next';
import { getDevice } from '../../helpers/device';
import { formatDateDefault, formatDatSemiShort, getLocale } from '../../helpers/dates';
import SpinnerLoader from '../Common/Spinner/SpinnerLoader';
import Header from '../Common/Header/Header';
import { WelletContext } from '../../context/WelletContext';
import { useSelector } from 'react-redux';

const TicketsDetailsSuccess = ({ lng, id }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const welletContext = useContext(WelletContext);
  const queryParams = new URLSearchParams(location.search);
  const [reservation, setReservation] = useState(null);
  const [error, setError] = useState(null);
  const isIOS = getDevice() === 'iOS';
  const indexTicket = queryParams.get('indexTicket');

  const token = queryParams.get('token');
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsTickets, setEventsTickets] = useState([]);

  const totalPages = eventsTickets?.length;

  const reservationTicketInfo = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(
        `/Reservation/tickets?token=${encodeURIComponent(token)}`,
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  };

  const getReservationTicketInfo = async () => {
    try {
      const result = await reservationTicketInfo(token);
      setEventsTickets(result);
    } catch (error) {
      setError(error.response?.data?.errorCode || 'Error desconocido');
    }
  };

  useEffect(() => {
    getReservationTicketInfo();
  }, []);

  const [isMounted, setIsMounted] = useState(false);
  const [addingToWallet, setAddingToWallet] = useState(false);


  useEffect(() => {
    setIsMounted(true);
  }, []);

  const downloadPKPass = (data) => {
    const { stream, type, fileName } = data;
    if (type === 'application/vnd.apple.pkpass') {
      const byteCharacters = atob(stream);
      const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type });
      const fileUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(fileUrl);
    } else {
      console.error('El tipo de archivo no es un PKPass.');
    }
  };

  const walletGoogle = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/google?token=${token}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const walletApple = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/apple?token=${token}`);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleWellet = async (tokenWellet) => {
    setAddingToWallet(true);
    try {
      if (isIOS) {
        const response = await walletApple(tokenWellet);
        downloadPKPass(response.data);
      } else if (isMounted) {
        const url = await walletGoogle(tokenWellet);
        if (url) {
          window.open(url);
        } else {
          console.error('No se recibió una URL válida de Google Wallet');
        }
      }
    } catch (error) {
      console.error('Error al agregar a la billetera:', error);
    } finally {
      setAddingToWallet(false);
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }
  if (reservation) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <div>
        <Header></Header>
      </div>

      <div>
        <Swiper
          onSlideChange={(indexTicket) => setCurrentPage(indexTicket.activeIndex + 1)}
          initialSlide={indexTicket}
          slidesPerView={1}
          pagination={{ clickable: true }}
        >
          {eventsTickets?.map((item, index) => (
            <SwiperSlide key={item.id}>
              <div>
                <div className={`${styles.cardWrap}`}>
                  <div className={`${styles.card} ${styles.cardRight}`}>
                    <div>
                      <img src={item.image} alt='Banner' className={styles.banner} />
                      <div className='d-flex flex-column mt-3'>
                        <span className={`${styles.title} fw-bold`}>{item.eventName}</span>

                        <div
                          className={`text-secondary font-extra-small`}
                          style={{ fontFamily: 'sans-serif' }}
                        >
                          {formatDatSemiShort(item.startDate, locale)} ~ {item.showName}
                        </div>
                        <div className={styles.lineLightGrey}></div>

                        <div className='row mt-2'>
                          <div className='col-7'>
                            <div>
                              <div className={`font-extra-small text-secondary`}>Ticket / Zona</div>
                              <div className={`${styles.colorBlack} font-tiny mt-1  bold`}>
                                {item.ticketName}
                              </div>
                            </div>
                          </div>

                          <div className='col-5'>
                            <div className={`font-extra-small text-secondary`}>Order Number</div>
                            <div className={`${styles.colorBlack} font-tiny mt-1  bold`}>
                              {item.individualReferenceCode}
                            </div>
                          </div>
                        </div>

                        <div className='row mt-3'>
                          <div className='col-7'>
                            <div>
                              <div className={`font-extra-small text-secondary`}>Date</div>
                              <div
                                className={`${styles.colorBlack} bold`}
                                style={{ fontFamily: 'sans-serif' }}
                              >
                                {formatDateDefault(item.startDate, locale)}
                              </div>
                            </div>
                          </div>

                          <div className='col-5'>
                            <div className={`${styles.fs12} text-secondary`}>Time</div>
                            <div className={`${styles.colorBlack} bold`}>
                              {`${format(new Date(item.startDate), 'h:mm a')}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.card} ${styles.cardMid}`}>
                    <div className={styles.qrContainer}>
                      {item.url && <img src={item.url} alt='QR' />}
                    </div>

                    <div className={`${styles.individualReferenceCode} text-center`}>
                      {t('scanRWntryGate')}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={styles.pageIndicator}>
        e-ticket {currentPage} de {totalPages}
      </div>
    </>
  );
};

export default TicketsDetailsSuccess;
